import { EditorState, AtomicBlockUtils } from "draft-js";

/**
 * 插入水平线
 *
 * @param {DraftEditorStore} store
 * @param {string} name
 * @param {Draft.SelectionState} selection
 */
export function insertHrAtomic(store) {
	const { getEditorState, setEditorState } = store;
	const editorState = getEditorState();
	const content = editorState.getCurrentContent();
	const contentWithEntity = content.createEntity('HR', 'IMMUTABLE', {});

	const entityKey = contentWithEntity.getLastCreatedEntityKey();

	const newEditorState = AtomicBlockUtils.insertAtomicBlock(
		EditorState.set(editorState, {
			currentContent: contentWithEntity,
			selection: editorState.getSelection(),
		}),
		entityKey,
		`----`,
	);
	setEditorState(newEditorState);
}



// WEBPACK FOOTER //
// ./lib/editor/DraftEditor/plugins/hrPlugin/modifier/insertHrAtomic.js